
export const DEFAULT_POPULAR_DESTINATIONS = [
    {
        c: 'IN',
        cy: 'Goa',
        cityName: 'Goa',
        k: '37264',
        s: 'Goa',
        stateName: 'Goa',
        sc: 'Goa,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Mumbai',
        cityName: 'Mumbai',
        k: '33719',
        s: 'Maharashtra',
        stateName: 'Maharashtra',
        sc: 'Maharashtra,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'New Delhi',
        k: '35485',
        s: 'Delhi',
        sc: 'Delhi,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Bangalore',
        cityName: 'Bangalore',
        k: '32550',
        s: 'Karnataka',
        stateName: 'Karnataka',
        sc: 'Karnataka,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Chennai',
        cityName: 'Chennai',
        k: '33070',
        s: 'Tamil Nadu',
        stateName: 'Tamil Nadu',
        sc: 'Tamil Nadu,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Hyderabad',
        cityName: 'Hyderabad',
        k: '33897',
        s: 'Telangana',
        stateName: 'Telangana',
        sc: 'Telangana,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Kolkata',
        cityName: 'Kolkata',
        k: '34600',
        s: 'West Bengal',
        stateName: 'West Bengal',
        sc: 'West Bengal,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Jaipur',
        cityName: 'Jaipur',
        k: '33968',
        s: 'Rajasthan',
        stateName: 'Rajasthan',
        sc: 'Rajasthan,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Pune',
        cityName: 'Pune',
        k: '35943',
        s: 'Maharashtra',
        stateName: 'Maharashtra',
        sc: 'Maharashtra,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    },
    {
        c: 'IN',
        cy: 'Udaipur',
        cityName: 'Udaipur',
        k: '36928',
        s: 'Rajasthan',
        stateName: 'Rajasthan',
        sc: 'Rajasthan,India',
        tp: '1',
        ty: 'c',
        suggestionType: 'CITY'
    }
];

export const POPULAR_DESTINATIONS_BY_LOCALE = {
    'AE' : [
        { c: 'AE', cy: 'Dubai', cityName: 'Dubai', k: '100074', s: 'Dubai', stateName: 'Dubai', sc: 'Dubai, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Abu Dhabi', cityName: 'Abu Dhabi', k: '101509', s: 'Abu Dhabi', stateName: 'Abu Dhabi', sc: 'Abu Dhabi, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Ras Al Khaimah', cityName: 'Ras Al Khaimah', k: '101902', s: 'Ras Al Khaimah (and vicinity)', stateName: 'Ras Al Khaimah (and vicinity)', sc: 'Ras Al Khaimah, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Ajman', cityName: 'Ajman', k: '101896', s: 'Ajman', stateName: 'Ajman', sc: 'Ajman, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Al Ain', cityName: 'Al Ain', k: '101897', s: 'Abu Dhabi', stateName: 'Abu Dhabi', sc: 'Al Ain, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Sharjah', cityName: 'Sharjah', k: '100770', s: 'Sharjah (and vicinity)', stateName: 'Sharjah (and vicinity)', sc: 'Sharjah (and vicinity), United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Fujairah', cityName: 'Fujairah', k: '101899', s: 'Fujairah', stateName: 'Fujairah', sc: 'Fujairah, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'IN', cy: 'Mumbai', cityName: 'Mumbai', k: '33719', s: 'Maharashtra', stateName: 'Maharashtra', sc: 'Maharashtra, India', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Al Aqah', cityName: 'Al Aqah', k: '133181', s: 'Fujairah', stateName: 'Fujairah', sc: 'Fujairah, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Riyadh', cityName: 'Riyadh', k: '408600', s: 'Riyadh', stateName: 'Riyadh', sc: 'Riyadh, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        ],
    'SA' : [
        { c: 'AE', cy: 'Dubai', cityName: 'Dubai', k: '100074', s: 'Dubai', stateName: 'Dubai', sc: 'Dubai, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Mecca', cityName: 'Mecca', k: '408546', s: null , stateName: null , sc: 'Mecca, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TR', cy: 'Istanbul', cityName: 'Istanbul', k: '421486', s: null, stateName: null, sc: 'Istanbul, Turkey', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Medina', cityName: 'Medina', k: '408590', s: null, stateName: null, sc: 'Medina, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'BH', cy: 'Manama', cityName: 'Manama', k: '401324', s: null, stateName: null, sc: 'Manama, Bahrain', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Jeddah', cityName: 'Jeddah', k: '408616', s: null, stateName: null, sc: 'Jeddah, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Riyadh', cityName: 'Riyadh', k: '408600', s: 'Riyadh', stateName: 'Riyadh', sc: 'Riyadh, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'EG', cy: 'Cairo', cityName: 'Cairo', k: '406448', s: 'Giza Governorate', stateName: 'Giza Governorate', sc: 'Giza Governorate, Egypt', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Al Aqah', cityName: 'Al Aqah', k: '133181', s: 'Fujairah', stateName: 'Fujairah', sc: 'Fujairah, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Abu Dhabi', cityName: 'Abu Dhabi', k: '101509', s: 'Abu Dhabi', stateName: 'Abu Dhabi', sc: 'Abu Dhabi, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        ],
    'BH' : [
        { c: 'TR', cy: 'Istanbul', cityName: 'Istanbul', k: '421486', s: null, stateName: null, sc: 'Istanbul, Turkey', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Dubai', cityName: 'Dubai', k: '100074', s: 'Dubai', stateName: 'Dubai', sc: 'Dubai, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'BH', cy: 'Manama', cityName: 'Manama', k: '401324', s: null, stateName: null, sc: 'Manama, Bahrain', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TH', cy: 'Patong', cityName: 'Patong', k: '183390', s: 'Phuket', stateName: 'Phuket', sc: 'Phuket, Thailand', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TH', cy: 'Pattaya', cityName: 'Pattaya', k: '107882', s: 'Chonburi', stateName: 'Chonburi', sc: 'Chonburi, Thailand', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'KW', cy: 'Kuwait City', cityName: 'Kuwait City', k: '400922', s: null, stateName: null, sc: 'Kuwait City, Kuwait', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TH', cy: 'Bangkok', cityName: 'Bangkok', k: '100073', s: 'Bangkok', stateName: 'Bangkok', sc: 'Bangkok, Thailand', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Mecca', cityName: 'Mecca', k: '408546', s: null, stateName: null, sc: 'Mecca, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'GB', cy: 'London', cityName: 'London', k: '100113', s: 'England', stateName: 'England', sc: 'England, United Kingdom', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'EG', cy: 'Cairo', cityName: 'Cairo', k: '406448', s: 'Giza Governorate', stateName: 'Giza Governorate', sc: 'Giza Governorate, Egypt', tp: '1', ty: 'c', suggestionType: 'CITY'},
        ],
    'QA' : [
        { c: 'QA', cy: 'Doha', cityName: 'Doha', k: '400768', s: null, stateName: null, sc: 'Doha, Qatar', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Dubai', cityName: 'Dubai', k: '100074', s: 'Dubai', stateName: 'Dubai', sc: 'Dubai, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'IN', cy: 'New Delhi', cityName: 'New Delhi', k: '35485', s: 'Delhi', stateName: 'Delhi', sc: 'Delhi, India', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TR', cy: 'Istanbul', cityName: 'Istanbul', k: '421486', s: null, stateName: null, sc: 'Istanbul, Turkey', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'OM', cy: 'Muscat', cityName: 'Muscat', k: '402022', s: null, stateName: null, sc: 'Muscat, Oman', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'GB', cy: 'London', cityName: 'London', k: '100113', s: 'England', stateName: 'England', sc: 'England, United Kingdom', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'IN', cy: 'Chennai', cityName: 'Chennai', k: '33070', s: 'Tamil Nadu', stateName: 'Tamil Nadu', sc: 'Tamil Nadu, India', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SG', cy: 'Singapore', cityName: 'Singapore', k: '100076', s: null, stateName: null, sc: 'Singapore, Singapore', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'IN', cy: 'Bangalore', cityName: 'Bangalore', k: '32550', s: 'Karnataka', stateName: 'Karnataka', sc: 'Karnataka, India', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'IN', cy: 'Mumbai', cityName: 'Mumbai', k: '33719', s: 'Maharashtra', stateName: 'Maharashtra', sc: 'Maharashtra, India', tp: '1', ty: 'c', suggestionType: 'CITY'},
        ],
    'KW' : [
        { c: 'AE', cy: 'Dubai', cityName: 'Dubai', k: '100074', s: 'Dubai', stateName: 'Dubai', sc: 'Dubai, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TR', cy: 'Istanbul', cityName: 'Istanbul', k: '421486', s: null, stateName: null, sc: 'Istanbul, Turkey', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TH', cy: 'Bangkok', cityName: 'Bangkok', k: '100073', s: 'Bangkok', stateName: 'Bangkok', sc: 'Bangkok, Thailand', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'BH', cy: 'Manama', cityName: 'Manama', k: '401324', s: null, stateName: null, sc: 'Manama, Bahrain', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Abu Dhabi', cityName: 'Abu Dhabi', k: '101509', s: 'Abu Dhabi', stateName: 'Abu Dhabi', sc: 'Abu Dhabi, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'GB', cy: 'London', cityName: 'London', k: '100113', s: 'England', stateName: 'England', sc: 'England, United Kingdom', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'SA', cy: 'Mecca', cityName: 'Mecca', k: '408546', s: null, stateName: null, sc: 'Mecca, Saudi Arabia', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'QA', cy: 'Doha', cityName: 'Doha', k: '400768', s: null, stateName: null, sc: 'Doha, Qatar', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'NL', cy: 'Amsterdam', cityName: 'Amsterdam', k: '407596', s: 'North Holland', stateName: 'North Holland', sc: 'North Holland, Netherlands', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'EG', cy: 'Cairo', cityName: 'Cairo', k: '406448', s: 'Giza Governorate', stateName: 'Giza Governorate', sc: 'Giza Governorate, Egypt', tp: '1', ty: 'c', suggestionType: 'CITY'},
        ],
    'OM' : [
        { c: 'AE', cy: 'Dubai', cityName: 'Dubai', k: '100074', s: 'Dubai', stateName: 'Dubai', sc: 'Dubai, United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'OM', cy: 'Muscat', cityName: 'Muscat', k: '402022', s: null, stateName: null, sc: 'Muscat, Oman', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'OM', cy: 'Salalah', cityName: 'Salalah', k: '402010', s: 'Dhofar Governorate', stateName: 'Dhofar Governorate', sc: 'Dhofar Governorate,Oman', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'US', cy: 'Houston', cityName: 'Houston', k: '441536', s: 'Texas', stateName: 'Texas', sc: 'Texas, United States', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'IN', cy: 'Mumbai', cityName: 'Mumbai', k: '33719', s: 'Maharashtra', stateName: 'Maharashtra', sc: 'Maharashtra, India', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TH', cy: 'Pattaya', cityName: 'Pattaya', k: '107882', s: 'Chonburi', stateName: 'Chonburi', sc: 'Chonburi, Thailand', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TH', cy: 'Bangkok', cityName: 'Bangkok', k: '100073', s: 'Bangkok', stateName: 'Bangkok', sc: 'Bangkok, Thailand', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'NL', cy: 'Amsterdam', cityName: 'Amsterdam', k: '407596', s: 'North Holland', stateName: 'North Holland', sc: 'North Holland, Netherlands', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'TR', cy: 'Istanbul', cityName: 'Istanbul', k: '421486', s:null, stateName:null, sc: 'Istanbul, Turkey', tp: '1', ty: 'c', suggestionType: 'CITY'},
        { c: 'AE', cy: 'Sharjah', cityName: 'Sharjah', k: '100770', s: 'Sharjah (and vicinity)', stateName: 'Sharjah (and vicinity)', sc: 'Sharjah (and vicinity), United Arab Emirates', tp: '1', ty: 'c', suggestionType: 'CITY'},
        ],
}